import axios from '@/lib/axios';
import { UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0310. チームメンバー編集
 * [PUT] /workspaces/:identifier/teams/:team_id/team_members/:team_member_id
 */
type Props = {
  identifier: string;
  team_id: number;
  team_member_id: number;
  'role_ids[]': string[];
  default_backofficer: boolean;
  default_approver: boolean;
};

const updateTeamMember = (props: Props): Promise<UserInvitation> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/team_members/${props.team_member_id}`,
    props
  );
};

export const useUpdateTeamMember = () => {
  return useMutation({
    mutationFn: updateTeamMember,
  });
};
